import React from 'react';
import { useTranslation } from 'react-i18next';
import MenuItemRow from './MenuItemRow';

export default function MenuItemsList({
  loading,
  menuItems,
  sectionOrder,
  currency,
  getImageUrl,
  togglingId,
  outOfStockReason,
  onAddItem,
  onOpenBulkTranslate,
  onReasonChange,
  onSaveReason,
  onToggleAvailability,
  onEditItem,
  onManageAddons,
  onSchedule,
  onDeleteItem,
}) {
  const { t } = useTranslation();

  return (
    <div className="admin-card">
      <div className="admin-card-header">
        <h3>📋 {t('admin.menuItems.title', 'Menu Items')}</h3>
        <div className="admin-header-actions">
          <button type="button" className="btn btn-secondary" onClick={onOpenBulkTranslate}>
            🌐 {t('translation.bulkTranslate')}
          </button>
          <button type="button" className="btn btn-primary" onClick={onAddItem}>
            ➕ {t('admin.addMenuItem.title')}
          </button>
        </div>
      </div>
      <div className="admin-card-body">
        {loading ? (
          <div className="menu-items-list">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="menu-item-card skeleton">
                <div className="skeleton-image" />
                <div className="skeleton-content">
                  <div className="skeleton-line w-3/4" />
                  <div className="skeleton-line w-1/2" />
                  <div className="skeleton-line w-1/4" />
                </div>
              </div>
            ))}
          </div>
        ) : menuItems.length === 0 ? (
          <div className="admin-empty-state">
            <div className="admin-empty-state-icon">🍽️</div>
            <h3>{t('admin.noItems', 'No menu items yet')}</h3>
            <p>{t('admin.noItemsHint', 'Add your first item or load from a template')}</p>
            <button type="button" className="btn btn-primary" onClick={onAddItem}>
              ➕ {t('admin.addMenuItem.title')}
            </button>
          </div>
        ) : (() => {
          const groupedBySection = {};
          menuItems.forEach((item) => {
            const section = item.section || 'Other';
            if (!groupedBySection[section]) groupedBySection[section] = [];
            groupedBySection[section].push(item);
          });
          let orderedSections = sectionOrder.filter((s) => groupedBySection[s]);
          const missingSections = Object.keys(groupedBySection).filter((s) => !orderedSections.includes(s));
          orderedSections = [...orderedSections, ...missingSections.sort()];

          return (
            <div className="menu-items-list">
              {orderedSections.flatMap((section) =>
                (groupedBySection[section] || [])
                  .sort((a, b) => {
                    const oa = a.display_order ?? 999999;
                    const ob = b.display_order ?? 999999;
                    return oa !== ob ? oa - ob : a.id - b.id;
                  })
                  .map((item) => (
                    <MenuItemRow
                      key={item.id}
                      item={item}
                      currency={currency}
                      getImageUrl={getImageUrl}
                      togglingId={togglingId}
                      outOfStockReason={outOfStockReason[item.id]}
                      onReasonChange={onReasonChange}
                      onSaveReason={onSaveReason}
                      onToggleAvailability={onToggleAvailability}
                      onEdit={onEditItem}
                      onManageAddons={onManageAddons}
                      onSchedule={onSchedule}
                      onDelete={onDeleteItem}
                    />
                  ))
              )}
            </div>
          );
        })()}
      </div>
    </div>
  );
}
